import { recordEvents } from "api/Analytics";
import { APP_VERSION } from "config/appVersion";

const FLUSH_INTERVAL_MS = 15_000;
const MAX_BATCH = 20;
const MAX_QUEUE = 100;

const CONTEXT = {
  platform: "web",
  osVersion: typeof navigator !== "undefined" ? navigator.userAgent : "",
  appVersion: APP_VERSION || "unknown",
};

let sessionId = generateSessionId();
let enabled = false;
let flushing = false;
let queue = [];
let flushTimer = null;

function generateSessionId() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function startNewSession() {
  sessionId = generateSessionId();
}

function ensureTimer() {
  if (!flushTimer) {
    flushTimer = setInterval(() => {
      void flush();
    }, FLUSH_INTERVAL_MS);
  }
}

function stopTimer() {
  if (flushTimer) {
    clearInterval(flushTimer);
    flushTimer = null;
  }
}

export function setAnalyticsEnabled(value) {
  enabled = value;
  if (enabled) {
    ensureTimer();
  } else {
    stopTimer();
    queue = [];
  }
}

export function track(name, category = "other", props) {
  if (!enabled) {
    return;
  }

  queue.push({
    name,
    category,
    props,
    sessionId,
    timestamp: new Date().toISOString(),
    ...CONTEXT,
  });

  if (queue.length > MAX_QUEUE) {
    queue = queue.slice(-MAX_QUEUE);
  }

  if (queue.length >= MAX_BATCH) {
    void flush();
  }
}

export function trackScreen(screen) {
  track("screen_view", "screen", { screen });
}

export function trackHeartbeat() {
  track("heartbeat", "lifecycle");
}

export async function flush() {
  if (!enabled || flushing || queue.length === 0) {
    return;
  }

  flushing = true;
  const batch = queue.slice(0, MAX_BATCH);

  try {
    const response = await recordEvents({ events: batch });
    if (response?.ok) {
      queue = queue.slice(batch.length);
    }
  } catch {
    // Keep the batch queued for the next flush.
  } finally {
    flushing = false;
  }
}
